import type { TermInterviewer } from "../../hooks";
import { Button } from "../ui/button";

interface InterviewerListSectionProps {
  /** このタームにアサイン済みのインタビュアー */
  assignedInterviewers: readonly TermInterviewer[];
  onAssign: () => void;
  onRemove: (interviewerId: string) => void;
}

export function InterviewerListSection({
  assignedInterviewers,
  onAssign,
  onRemove,
}: InterviewerListSectionProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-[var(--color-border-default)] bg-white shadow-[0_2px_8px_rgba(0,0,0,0.05)]">
      <div className="flex items-center justify-between border-[var(--color-primary-500)] border-b-2 bg-[var(--color-bg-subtle-gray)] px-6 py-5">
        <h2 className="font-bold text-2xl text-[var(--color-primary-500)]">
          インタビュアー一覧
        </h2>
        <Button size="sm" onClick={onAssign}>
          アサイン
        </Button>
      </div>
      <div className="p-6">
        {assignedInterviewers.length === 0 ? (
          <div className="p-8 text-center text-[var(--color-text-secondary)]">
            インタビュアーがアサインされていません
          </div>
        ) : (
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[var(--color-bg-subtle-gray)]">
                <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                  ID
                </th>
                <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                  名前
                </th>
                <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                  メールアドレス
                </th>
                <th className="whitespace-nowrap p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                  カレンダー連携
                </th>
                <th className="whitespace-nowrap p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                  担当件数
                </th>
                <th className="p-3 text-left font-semibold text-[var(--color-text-secondary)] text-xs">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>
              {assignedInterviewers.map((interviewer) => (
                <tr
                  key={interviewer.interviewerId}
                  className="border-[var(--color-border-default)] border-b"
                >
                  <td className="p-3 text-sm">
                    {interviewer.interviewerId.slice(-8)}
                  </td>
                  <td className="p-3 text-sm">
                    {interviewer.name || interviewer.email}
                  </td>
                  <td className="p-3 text-[13px] text-[var(--color-text-secondary)]">
                    {interviewer.email}
                  </td>
                  <td className="whitespace-nowrap p-3 text-sm">
                    <CalendarLinkCell
                      accountCount={interviewer.linkedGoogleAccountCount}
                    />
                  </td>
                  <td className="whitespace-nowrap p-3 text-sm">
                    {interviewer.assignedInterviewCount}件
                  </td>
                  <td className="p-3">
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={() => onRemove(interviewer.interviewerId)}
                    >
                      削除
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

/** 未連携だと外部カレンダーの予定と突き合わせずに枠を出すので、注意を引く色にする */
function CalendarLinkCell({ accountCount }: { accountCount: number }) {
  if (accountCount === 0) {
    return <span className="text-[#b45309]">未連携</span>;
  }
  return <span>連携済み（{accountCount}アカウント）</span>;
}
